import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { disclaimer } from '../data/teaser';
interface PhoneFrameProps {
  step: number;
  total: number;
  children: React.ReactNode;
  footnote?: string;
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  /** Opens the internal strategy document. */
  onOpenStrategy: () => void;
}
export function PhoneFrame({
  step,
  total,
  children,
  footnote,
  onBack,
  onNext,
  nextLabel = 'Continue',
  nextDisabled = false,
  onOpenStrategy
}: PhoneFrameProps) {
  return <div className="flex min-h-full w-full items-center justify-center bg-mist px-5 py-8" data-id="element-25" data-mp="2gknrj0w8qzd3">
      <div className="flex w-full max-w-5xl items-center justify-center gap-16" data-id="element-26" data-mp="2giulnntgcj65">
        <aside className="hidden max-w-xs flex-1 lg:block" data-id="element-27" data-mp="2liyz14z2cxs5">
          <p className="text-[10px] uppercase tracking-micro text-mut" data-id="element-28" data-mp="m7o6gs93dcyf">
            Unbranded disease awareness · medical retina
          </p>
          <h1 className="mt-5 font-display text-4xl font-semibold leading-[1.05] text-navy" data-id="element-29" data-mp="r7tr3ogy1z70">
            See beyond
            <br data-id="element-30" data-mp="3461gtpw1czbf" />
            the fluid.
          </h1>
          <p className="mt-5 text-sm leading-relaxed text-mut" data-id="element-31" data-mp="3459n6km01bns">
            A 60-second teaser for Danish retina specialists on DME phenotypes and AI-assisted OCT
            biomarker analysis.
          </p>
          <p className="mt-6 text-[11px] uppercase tracking-micro text-mut" data-id="element-32" data-mp="2v6xumd1ko3sp">
            Screen {step + 1} of {total}
          </p>
          <p className="mt-6 border-t border-line pt-4 text-[11px] leading-relaxed text-mut" data-id="element-33" data-mp="3mwj6fllknesk">
            {disclaimer}
          </p>
        </aside>

        <div className="flex w-full max-w-[400px] flex-col" data-id="element-34" data-mp="3itmidfd9iqh8">
          <div className="flex aspect-[9/16] w-full flex-col overflow-hidden rounded-[34px] border border-line bg-paper shadow-soft" data-id="element-35" data-mp="3dw4i0ddb9jku">
            <div className="flex justify-end px-6 pt-5" data-id="element-36" data-mp="27gk2ynmwg6yn">
              <button type="button" onClick={onOpenStrategy} className="rounded-full border border-blue/60 bg-paper px-3 py-1 text-[10.5px] font-medium text-navy transition-colors duration-150 hover:border-blue hover:bg-sky/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-37" data-mp="22gz38azwnukv">
                Strategy
              </button>
            </div>

            <div className="flex flex-1 flex-col overflow-y-auto px-6 pb-5 pt-3" data-id="element-38" data-mp="1yy0bwssgucr1">{children}</div>

            {(onNext || onBack || footnote) && <div className="border-t border-line px-6 py-4" data-id="element-39" data-mp="1l5ab3i8a339v">
                {footnote && <p className="mb-3 text-[9px] leading-relaxed text-mut" data-id="element-40" data-mp="1pzoarwtz3wkc">{footnote}</p>}
                {(onNext || onBack) && <div className="flex items-center gap-2" data-id="element-41" data-mp="1b7cnmwy8taib">
                    {onBack && <button type="button" onClick={onBack} aria-label="Previous screen" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-line text-mut transition-colors duration-150 hover:border-mut hover:text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-42" data-mp="1g67dujyji1cg">
                        <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-43" data-mp="wmqpgbalgcvy" />
                      </button>}
                    {onNext && <button type="button" onClick={onNext} disabled={nextDisabled} className="flex h-11 flex-1 items-center justify-center gap-2 rounded-full bg-navy px-5 text-[13px] font-medium text-paper transition-opacity duration-150 hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue focus-visible:ring-offset-2 disabled:opacity-30" data-id="element-44" data-mp="16kodoysge9ok">
                        {nextLabel}
                        <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-45" data-mp="1kckzym7fxpd1" />
                      </button>}
                  </div>}
              </div>}
          </div>
        </div>
      </div>
    </div>;
}